<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-alert variant="danger"
                  dismissible
                  :show="failure"
                  @dismissed="failure=false">
                  {{message}}
                </b-alert>
                <b-form class="login" @submit.prevent="resetPassword">
                  <h1>Reset Password</h1>
                  <p class="text-muted">Submit the form to choose your new password.</p>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="newPassword" name="new_password" class="form-control" placeholder="New Password" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="confirmPassword" name="confirm_password" class="form-control" placeholder="Confirm New Password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" name="submit" variant="primary" class="px-4">Submit</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <router-link class="btn px-0 btn-link" to="login">
                        <i class="fa fa-chevron-left"></i> Back to login
                      </router-link>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ResetPassword',
  data () {
    return {
      confirmPassword: '',
      newPassword: '',
      failure: false,
      message: ''
    }
  },
  methods: {
    /**
     * Sends reset password information to the backend API.
     */
    resetPassword: function () {
      let self = this

      axios.put(`${process.env.VUE_APP_API_URL}api/admins/reset_password`, {
        password: self.newPassword,
        confirm_password: self.confirmPassword,
        code: self.$route.query.code,
        admin_id: self.$route.query.admin_id
      })
        .then(function (response) {
          self.$router.push('/')
        })
        .catch(function (error) {
          let data = error.response.data

          if (data.success === false) {
            self.failure = true
            self.message = data.message
          }
        })
    }
  },
  mounted () {
    let self = this

    axios.post(`${process.env.VUE_APP_API_URL}api/admins/verify_code`, {
      code: self.$route.query.code,
      admin_id: self.$route.query.admin_id
    })
      .catch(function (error) {
        let data = error.response.data

        if (data.success === false) {
          self.failure = true
          self.message = data.message
        }
      })
  }
}
</script>
